import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { CallEntity, CallEntityKind, CallParticipant } from "../../shared/models/webrtc/call/v2/call-entity";
import { DeviceOutput } from "../../devices/models/device_output";
import { CallSession } from "./current-call-state";

export const CurrentCallActions = createActionGroup({
  source: "CurrentCall",
  events: {
    // Start a new call (outgoing or incoming)
    StartCall: props<{
      callId: string;
      installationId: string;
      callee: CallParticipant;
      incoming?: boolean;
      originalCallee?: CallEntity;
      destination?: CallEntity;
    }>(),

    // A new session was created (pending/started)
    SessionStarted: props<{
      callId: string;
      session: CallSession;
    }>(),

    // A session was answered - becomes active
    SessionAnswered: props<{
      callId: string;
      sessionId: string;
    }>(),

    // Put current active session on hold
    Hold: props<{
      callId: string;
    }>(),

    // Resume the held session
    Resume: props<{
      callId: string;
    }>(),

    // Start forwarding (while on hold) - creates mainLeg in outgoing state
    StartForward: props<{
      callId: string;
      callee: CallParticipant;
    }>(),

    // A session ended
    SessionEnded: props<{
      callId: string;
      sessionId: string;
    }>(),

    // Call error occurred
    CallError: props<{
      callId: string;
      error: string;
    }>(),

    // Clear mainLeg (e.g. cancel forward) while keeping pipLeg on hold
    ClearMainLeg: props<{
      callId: string;
    }>(),

    // Reset a specific call (remove from array)
    Reset: props<{
      callId: string;
    }>(),

    // Reset all calls to idle state
    ResetAll: emptyProps(),

    // Set the active call
    SetActiveCall: props<{
      callId: string;
    }>(),

    // Bridge: connect held caller with active caller directly
    Bridge: props<{
      callId: string;
    }>(),

    // Update session entity info (name, outputs, thingName, version)
    UpdateSessionEntityInfo: props<{
      callId: string;
      sessionId: string;
      entityName?: string;
      entityOutputs?: DeviceOutput[];
      entityThingName?: string;
      entityIsV2?: boolean;
    }>(),

  },
});
